export default "__VITE_ASSET__YPPzFx7i__"